module.exports = __webpack_public_path__ + "img/logo.74edc447.jpg";